/**
 * The visitor's cookie choice: "accepted" (measurement on), "declined"
 * (necessary storage only) or null (not asked yet). public/index.html loads
 * PostHog only when the stored choice says "accepted" (window.toukkyStartAnalytics);
 * declined or unanswered, no PostHog script or request at all. This is the one
 * place that loads it on Accept, or turns it off afterwards.
 */
export const CONSENT_KEY = "toukky_cookie_consent";
const EVENT = "toukky:cookie-consent";

export function readConsent() {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === "accepted" || value === "declined" ? value : null;
  } catch { return null; }
}

function applyToAnalytics(choice) {
  if (typeof window === "undefined") return;
  // Keep the consent choice, but never enable recording on a private group page.
  if (choice === "accepted" && /^\/groups(?:\/|$)/.test(window.location.pathname)) return;
  try {
    // The first Accept of the visit adds PostHog's script (once); a decline
    // never does. Until it was started, the stub has none of the calls below.
    if (choice === "accepted") window.toukkyStartAnalytics?.();
    const ph = window.posthog;
    if (!ph) return;
    if (choice === "accepted") {
      ph.set_config?.({ persistence: "localStorage+cookie", disable_session_recording: false });
      ph.opt_in_capturing?.();
      ph.startSessionRecording?.();
    } else {
      ph.stopSessionRecording?.();
      ph.opt_out_capturing?.();
      ph.set_config?.({ persistence: "memory", disable_session_recording: true });
    }
  } catch { /* analytics never breaks the page */ }
}

/** Store a choice (or null to ask again) and tell the banner. */
export function setConsent(choice) {
  try {
    if (choice) localStorage.setItem(CONSENT_KEY, choice);
    else localStorage.removeItem(CONSENT_KEY);
  } catch { /* storage blocked: the choice lasts this visit */ }
  if (choice) applyToAnalytics(choice);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: choice }));
}

export function onConsentChange(fn) {
  const handler = (e) => fn(e.detail ?? null);
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
